import AgGridSolid from "./grid/agGridSolid";
export default AgGridSolid;

export * from "./grid/agGridSolid";

// /* @refresh reload */
// import { render } from 'solid-js/web';
//
// import './index.css';
// import App from './sampleApp/App';
//
// render(() => <App />, document.getElementById('root') as HTMLElement);
